module.exports = __webpack_public_path__ + "img/43_70.05452319.png";